import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ap-systems',
  templateUrl: './ap-systems.component.html',
  styleUrls: ['./ap-systems.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ApSystemsComponent {
  title: string = 'Ap Systems';
  suppliedQueryData: { [key: string]: any } = {};

  constructor(private Router: Router) {
    const navigation = this.Router.currentNavigation();

    if (navigation) {
      const { extras } = navigation;

      if (extras) {
        const { state } = extras;

        if (state) {
          const { query, title } = state;

          if (title) {
            this.title = title;
          }

          if (query) {
            Object.assign(this.suppliedQueryData, query);
          }
        }
      }
    }
  }
}
